module.exports = __webpack_public_path__ + "img/chat.f2338c75.svg";